import { render } from "./GraphData.vue?vue&type=template&id=533f8bf3&scoped=true"
import script from "./GraphData.vue?vue&type=script&lang=js"
export * from "./GraphData.vue?vue&type=script&lang=js"

import "./GraphData.vue?vue&type=style&index=0&id=533f8bf3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-533f8bf3"

export default script